/**
 * Need... private functions to check that session is fit for any given screen of the app.
 * If not... redirect to most suitable screen
 */
import router from "@/router/index";
import { urlParams } from "@/utils/index";
import config from "@/config";

//  Return querystring params minus fields from preceding webforms
const filteredQuery = () => {
    let query = urlParams();
    const fields = [
        "first_name", "firstname", "last_name", "lastname", "surname",
        "tel", "tel_number", "tel_no", "telnumber", "telno",
        "phone", "phone_number", "phone_no", "phonenumber", "phoneno",
        "email", "email_address", "emailaddress", "offer"
    ];
    fields.forEach(field => {
        if (query[field]) delete query[field];
    });
    return query;
};

const routerPushIfDifferentRouteName = (router, routeName, session = false) => {
    const query = filteredQuery();

    //  Need to get params from session because maybe we're here from a custom URL
    if(session) {
        const custom_url_params = session.custom_url_json?.params ?? [];        
        custom_url_params.forEach((param) => {
            query[param.key] = param.value;
        });
    }

    if(router.currentRoute.name != routeName) {
        router.push({ name: routeName, query });
    }
};

const routerRedirectToStep = (step, session = false) => {
    // console.log(`routerRedirectToStep.session`, session);
    
    switch(step) {
        case "FINISHED":
            routerPushIfDifferentRouteName(router, "finished", session); 
            break;
        case "CHECKOUT":
            routerPushIfDifferentRouteName(router, "checkout", session); 
            break;
        case "ABOUT_YOU":
            routerPushIfDifferentRouteName(router, "about-you", session); 
            break;
        default:
            routerPushIfDifferentRouteName(router, "reserve-appointment", session); 
    }
};

const routerRedirectWithSessionid = (_routeName, sessionid) => {
    const query = filteredQuery();
    query.sessionid = sessionid;
};

const routerRedirectWithQueryStringParams = () => {
    //router.push({ name: routeName, query: filteredQuery() });
};

const hostProtocol = () => {
    if(window.location.href.indexOf("localhost") >= 0) {
        return "http://";
    }
    else {
        return "https://";
    }
}

const hostDomain = () => {
    if(window.location.href.indexOf("localhost") >= 0) {
        return "localhost:8080";
    }
    else {
        return config.hostDomain;
    }
};

const hostPathSuffix = () => {
    if(hostDomain().indexOf("book.willowlife") >= 0) {
        return "";
    }
    else {
        return "/book-online";
    }
};

const hostRoot = () => {
    return `${hostProtocol()}${hostDomain()}${hostPathSuffix()}`;
};

const redirectToLandingUrl = (customUrlCode = false) => {
    if(customUrlCode) {
        window.location.replace(`${hostRoot()}/?offer=${customUrlCode}`);
    }
    else {
        hardRedirectToHome();
    }
};

const hardRedirectToHome = () => { window.location.replace(hostRoot() + "/"); };

const stripeRedirectParams = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const found = {
        payment_intent: false,
        payment_intent_client_secret: false,
        redirect_status: false
    };

    for (const [ key, value ] of searchParams.entries()) {
        if(key == "payment_intent") {
            found.payment_intent = value;
        }

        if(key == "payment_intent_client_secret") {
            found.payment_intent_client_secret = value;
        }

        if(key == "redirect_status") {
            found.redirect_status = value;
        }
    }

    if(!found.payment_intent || !found.payment_intent_client_secret || !found.redirect_status) {
        return false;
    }

    return found;
};

export { routerRedirectWithQueryStringParams, routerRedirectToStep, routerRedirectWithSessionid, redirectToLandingUrl, hardRedirectToHome, stripeRedirectParams, hostPathSuffix, hostRoot };
